'use client'

import { useTranslations } from 'next-intl'

function EmbeddedAdultOverlay() {
  const t = useTranslations('worlds.embedded-adult-block')

  return (
    <div className="fixed inset-0 z-navigation flex items-center justify-center border border-white/80 bg-black">
      <p className="px-6 text-center text-balance text-white">{t('message')}</p>
    </div>
  )
}

export default EmbeddedAdultOverlay
